export enum AudioClips
{
  UI_CLICK = "ui_click",

  CANNON_SHOT = "cannon_shot",

  TEN_SHOTS_SINGLE = "ten_shots_single",
  BIG_SHOT = "big_shot",
  BIG_SHOT_HIT = "big_shot_hit",
  BOOSTER_APPEAR = "booster_appear",
  INFINITE_SHOTS_MUSIC = "infinite_shots_music",
  ROCKET_FLY = "rocket_fly",
  ROCKET_HIT = "rocket_hit",

  COINS_GROUP_FLY = "coins_group_fly",

  MUSIC_MAIN = "music_main",
  MUSIC_GAME_LOOP = "music_game_loop",
  MUSIC_BLOCK_JUMP = "music_block_jump",
  MUSIC_ESCALATOR = "music_escalator",

  GLASS_CUBE_DROP_1 = "glass_cube_drop_1",
  GLASS_CUBE_DROP_2 = "glass_cube_drop_2",
  JAR_SHATTER = "jar_shatter",
  ICE_HIT = "ice_hit",
  PUMPKIN_HIT = "pumpkin_hit",
  PLASTIC_HIT_1 = "plastic_hit_1",
  PLASTIC_HIT_2 = "plastic_hit_2",
  METAL_CUBE_HIT = "metal_cube_hit",
  METAL_ROUND_HIT = "metal_round_hit",
  TIN_CAN_HIT_1 = "tin_can_hit_1",
  TIN_CAN_HIT_2 = "tin_can_hit_2",
  STONE_CUBE_HIT = "stone_cube_hit",
  STONE_CUBE_DROP_1 = "stone_cube_drop_1",
  STONE_CUBE_DROP_2 = "stone_cube_drop_2",
  WOOD_CUBE_DROP_1 = "wood_cube_drop_1",
  WOOD_CUBE_DROP_2 = "wood_cube_drop_2",
  WOOD_CUBE_HIT = "wood_cube_hit",

  LOSE_GAME = "lose_game",
  SEARCH_LEVEL = "search_level",
  START_LEVEL = "start_level",
  WIN_GAME = "win_game",
}


export const AUDIO_PATHS: Record<AudioClips, string> = {
  [AudioClips.UI_CLICK]: "assets/sounds/UI_CLICK.wav?v=2",

  [AudioClips.CANNON_SHOT]: "assets/sounds/CANNON.mp3?v=2",
  [AudioClips.TEN_SHOTS_SINGLE]: "assets/sounds/booster_sounds/10_SHOTS_SINGLE.mp3?v=2",
  [AudioClips.BIG_SHOT]: "assets/sounds/booster_sounds/BIG_SHOT.mp3?v=2",
  [AudioClips.BIG_SHOT_HIT]: "assets/sounds/booster_sounds/BIG_SHOT_HIT.mp3?v=2",
  [AudioClips.BOOSTER_APPEAR]: "assets/sounds/booster_sounds/BOOSTER_APPEAR.mp3?v=2",
  [AudioClips.INFINITE_SHOTS_MUSIC]: "assets/sounds/booster_sounds/INFINITE_SHOTS_MUSIC_5_SEC.mp3?v=2",
  [AudioClips.ROCKET_FLY]: "assets/sounds/booster_sounds/ROCKET_FLY.mp3?v=2",
  [AudioClips.ROCKET_HIT]: "assets/sounds/booster_sounds/ROCKET_HIT.mp3?v=2",
  
  [AudioClips.COINS_GROUP_FLY]: "assets/sounds/COINS_GROUP_FLY.mp3?v=2",

  [AudioClips.LOSE_GAME]: "assets/sounds/LOSE_GAME.mp3?v=2",
  [AudioClips.SEARCH_LEVEL]: "assets/sounds/SEARCH_LEVEL.mp3?v=2",
  [AudioClips.START_LEVEL]: "assets/sounds/START_LEVEL.mp3?v=3",
  [AudioClips.WIN_GAME]: "assets/sounds/WIN_GAME.mp3?v=2",

  [AudioClips.MUSIC_MAIN]: "assets/sounds/MUSIC_MAIN.mp3?v=1",
  [AudioClips.MUSIC_GAME_LOOP]: "assets/sounds/MUSIC_GAME_LOOP.mp3?v=1",
  [AudioClips.MUSIC_BLOCK_JUMP]: "assets/sounds/MUSIC_BLOCK_JUMP.mp3?v=1",
  [AudioClips.MUSIC_ESCALATOR]: "assets/sounds/MUSIC_ESCALATOR.mp3?v=1",

  [AudioClips.GLASS_CUBE_DROP_1]: "assets/sounds/GLASS_CUBE_DROP_1.mp3?v=3",
  [AudioClips.GLASS_CUBE_DROP_2]: "assets/sounds/GLASS_CUBE_DROP_2.mp3?v=3",
  [AudioClips.JAR_SHATTER]: "assets/sounds/JAR_SHATTER.mp3?v=1",
  [AudioClips.ICE_HIT]: "assets/sounds/ICE_HIT.mp3?v=1",
  [AudioClips.PUMPKIN_HIT]: "assets/sounds/PUMPKIN_HIT.mp3?v=1",
  [AudioClips.PLASTIC_HIT_1]: "assets/sounds/PLASTIC_HIT_1.mp3?v=1",
  [AudioClips.PLASTIC_HIT_2]: "assets/sounds/PLASTIC_HIT_2.mp3?v=1",
  [AudioClips.METAL_CUBE_HIT]: "assets/sounds/METAL_CUBE_HIT.mp3?v=3",
  [AudioClips.METAL_ROUND_HIT]: "assets/sounds/METAL_ROUND_HIT.mp3?v=1",
  [AudioClips.TIN_CAN_HIT_1]: "assets/sounds/TIN_CAN_HIT_1.mp3?v=1",
  [AudioClips.TIN_CAN_HIT_2]: "assets/sounds/TIN_CAN_HIT_2.mp3?v=1",
  [AudioClips.STONE_CUBE_HIT]: "assets/sounds/STONE_CUBE_HIT.mp3?v=2",
  [AudioClips.STONE_CUBE_DROP_1]: "assets/sounds/STONE_CUBE_DROP_1.mp3?v=1",
  [AudioClips.STONE_CUBE_DROP_2]: "assets/sounds/STONE_CUBE_DROP_2.mp3?v=1",
  [AudioClips.WOOD_CUBE_DROP_1]: "assets/sounds/WOOD_CUBE_DROP_1.mp3?v=3",
  [AudioClips.WOOD_CUBE_DROP_2]: "assets/sounds/WOOD_CUBE_DROP_2.mp3?v=3",
  [AudioClips.WOOD_CUBE_HIT]: "assets/sounds/WOOD_CUBE_HIT.mp3?v=3",
};

export const MUSIC_PLAYLIST: AudioClips[] = [ AudioClips.MUSIC_MAIN, AudioClips.MUSIC_GAME_LOOP, AudioClips.MUSIC_BLOCK_JUMP ];
export const MUSIC_PLAYS_PER_TRACK = 10;
